import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';

const Wrapper = styled.section`
  background-color: ${brand.nearlyBlack};
  padding: 10px 0;

  @media ${from(Device.TabletLarge)} {
    padding: 30px 0;
  }
`;

const TitleStyles = css`
  ${fonts.helvetica['73-bold-extended']};
  font-size: 14px;
  letter-spacing: ${fonts.ls(26)};
  color: ${brand.grey[55]};
  text-transform: uppercase;
`;

const Title = styled.h2`
  ${TitleStyles};
  margin: 0 0 14px;
  display: none;

  @media ${from(Device.TabletLarge)} {
    display: block;
  }
`;

const TitleAccordian = styled.h3`
  ${TitleStyles};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  margin: 6px 0;
  cursor: pointer;

  span {
    margin-right: 14px;
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;

const Icon = styled(m.div)`
  display: inline-flex;
  align-items: center;
  width: 12px;
  height: 12px;
  transform-origin: center center;

  svg {
    width: 12px;
    height: 12px;
    color: ${brand.grey[55]};
  }
`;

const List = styled(m.ul)`
  overflow: hidden;
  margin-bottom: 16px;

  @media ${from(Device.TabletLarge)} {
    display: flex;
    align-items: flex-start;
    gap: 30px;
    margin-bottom: unset !important; // remove margin from framer-motion
    height: auto !important; // always visible on desktop
    flex-wrap: wrap;
  }
`;

const Item = styled.li`
  margin-bottom: 12px;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: unset;
  }

  &:last-child {
    margin-bottom: unset;
  }
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${brand.white};
  ${fonts.helvetica['53-extended']};
  font-size: 12px;
  line-height: 1.2;

  &:hover {
    color: ${brand.white};
    text-decoration: underline;
  }

  svg {
    width: 12px;
    height: 12px;
    color: ${brand.red.base};
  }
`;

export default {
  Wrapper,
  Title,
  TitleAccordian,
  Icon,
  List,
  Item,
  Link,
};
